import { render, staticRenderFns } from "./ChatAssigned.vue?vue&type=template&id=11fdedda&scoped=true"
import script from "./ChatAssigned.vue?vue&type=script&lang=js"
export * from "./ChatAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fdedda",
  null
  
)

export default component.exports